import React from 'react';

import { INothingFound, NothingFound } from '../../NotFound';

export interface IRealtorRatingTableTbodyNotFound {
  showResetFiltersLink?: INothingFound['showResetFiltersLink'];
}

/**
 * Пустое тело таблицы рейтинга риелторов
 */
export const RealtorRatingTableTbodyNotFound = ({ showResetFiltersLink }: IRealtorRatingTableTbodyNotFound ) => {
  return (
    <tbody>
      <tr>
        <td colSpan={9}>
          <NothingFound
            pathname={'/reyting-rieltorov/'}
            showResetFiltersLink={showResetFiltersLink}
            hasDescription={false}
          />
        </td>
      </tr>
    </tbody>
  );
};
